module.exports = __webpack_public_path__ + "fonts/Rubik-Black.1e6fa1d.ttf";